import { takeLatest, put, all, call } from 'redux-saga/effects';

import MemberAttendanceReportActionTypes from './member-attendance-report.types';

import {
	memberAttendanceReportListGet,
	memberAttendanceReportExcelListGet,
} from './member-attendance-report.service';

import {
	getMemberAttendanceReportDetailsSuccess,
	getMemberAttendanceReportDetailsFailure,
	getMemberAttendanceReportDetailsResponseChanged,
	fetchMemberAttendanceReportExcelSuccess,
	fetchMemberAttendanceReportExcelFailure,
	fetchMemberAttendanceReportResponseExcelResetChanged,
} from './member-attendance-report.action';

import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START GET MEMBER ATTENDANCE REPORT DETAILS  ******************** */
export function* getMemberAttendanceReportList({ payload }: any) {
	try {
		const key = 'GetMemberAttendanceReportKey';
		const { companyID, branchID, centerID, databaseName, fromDate, toDate, setDateType } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			Location: centerID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			DateFilter: setDateType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberAttendanceReportListGet, encodeData);
		if (responseData.data.statusCode === '01') {
			yield put(getMemberAttendanceReportDetailsSuccess(responseData.data));
		} else {
			yield put(getMemberAttendanceReportDetailsFailure(responseData.data));
		}
	} catch (error) {
		yield put(getMemberAttendanceReportDetailsFailure(error));
	}
}

export function* resetgetMemberAttendanceReportListResponse() {
	yield put(getMemberAttendanceReportDetailsResponseChanged());
}

export function* onGetMemberAttendanceReportListDetails() {
	yield takeLatest(
		MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_LIST_START,
		getMemberAttendanceReportList,
	);
}

export function* onGetMemberAttendanceReportListResponseReset() {
	yield takeLatest(
		MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_LIST_RESPONSE_RESET,
		resetgetMemberAttendanceReportListResponse,
	);
}
/** *********************  END GET MEMBER ATTENDANCE REPORT DETAILS ******************** */

/** *********************  START GET MEMBER ATTENDANCE REPORT EXCEL  ******************** */
export function* getMemberAttendanceReportExcelList({ payload }: any) {
	try {
		const key = 'MemberAttendanceReportExport';
		const jsonData = {
			companyID: payload.companyID,
			branchID: payload.BranchID,
			centerID: payload.CenterID,
			DatabaseName: payload.DatabaseName,
			FromDate: payload.FromDate,
			ToDate: payload.ToDate,
			UserID: payload.UserID,
			GeneralCompanyID: payload.generalCompanyID,
			RequestID: payload.RequestID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberAttendanceReportExcelListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchMemberAttendanceReportExcelFailure(responseData.data));
		} else {
			yield put(fetchMemberAttendanceReportExcelSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchMemberAttendanceReportExcelFailure(error));
	}
}

export function* resetGetMemberAttendanceReportExcelListResponse() {
	yield put(fetchMemberAttendanceReportResponseExcelResetChanged());
}

export function* onGetMemberAttendanceReportExcelListDetails() {
	yield takeLatest(
		MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_EXCEL_START,
		getMemberAttendanceReportExcelList,
	);
}

export function* onGetMemberAttendanceReportExcelListResponseReset() {
	yield takeLatest(
		MemberAttendanceReportActionTypes.GET_MEMBER_ATTENDANCE_REPORT_EXCEL_RESPONSE_RESET,
		resetGetMemberAttendanceReportExcelListResponse,
	);
}
/** *********************  END GET MEMBER ATTENDANCE REPORT EXCEL ******************** */

export function* memberAttendanceReportSaga() {
	yield all([
		call(onGetMemberAttendanceReportListDetails),
		call(onGetMemberAttendanceReportListResponseReset),
		call(onGetMemberAttendanceReportExcelListDetails),
		call(onGetMemberAttendanceReportExcelListResponseReset),
	]);
}
